import { createReducer } from '@reduxjs/toolkit';
import {
    MEDIA_ENDED, PAUSE_MEDIA_PLAYER, PLAY_LIVE,
} from '../../aovivoBar/actions/MediaPlayerActions';
import {
    SET_TOP_SONGS,
    IS_PLAY_TOP_SONG,
    IS_PAUSE_TOP_SONG,
    SET_IS_LOADING_TOP_SONGS,
    RESET_TOP_SONGS,
} from '../actions/ArtistTopSongsActions';

const initialState = {
    artist: null,
    listTopSongs: [],
    isFetching: false,
    isPlayTopSong: false,
};

const ArtistTopSongs = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_TOP_SONGS, (state, action) => {
            state.artist = action.artist;
            state.listTopSongs = action.listTopSongs;
        })
        .addCase(SET_IS_LOADING_TOP_SONGS, (state, action) => {
            state.isFetching = action.status;
        })
        .addCase(RESET_TOP_SONGS, (state) => {
            state.artist = initialState.artist;
            state.listTopSongs = initialState.listTopSongs;
        })
        .addCase(IS_PLAY_TOP_SONG, (state, action) => {
            state.isPlayTopSong = action.previewTopSong;
        })
        .addCase(PLAY_LIVE, (state) => {
            state.isPlayTopSong = false;
        })
        .addCase(PAUSE_MEDIA_PLAYER, (state) => {
            state.isPlayTopSong = false;
        })
        .addCase(MEDIA_ENDED, (state) => {
            state.isPlayTopSong = false;
        })
        .addCase(IS_PAUSE_TOP_SONG, (state) => {
            state.isPlayTopSong = false;
        });
});

export default ArtistTopSongs;
